import { createCustomInterceptorInstance } from '@fundacao/shared-components/esm/ie/renovacao';

const userSessionApi = createCustomInterceptorInstance(
    process.env.REACT_APP_USER_SESSION_API,
);
  
export async function verificarAceiteTermosDeUso(): Promise<any> {
    const response = await userSessionApi.get('/usuarios-ies/termos-uso/validar-aceite', {
        headers: { Authorization: `${localStorage.getItem('tokenIES')}` },
    });

    return response.data;
}

export async function aceitarTermosDeUso(): Promise<any> {
    const response = await userSessionApi.post('/usuarios-ies/termos-uso', {}, {
        headers: { Authorization: `${localStorage.getItem('tokenIES')}` },
    });

    return response.data;
}